import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  objects?: Types.InputMaybe<Types.Users_Set_Input>;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, firstName: string, lastName: string, profession?: string | null, specialty?: string | null, specialtyId?: any | null, location?: string | null, title?: string | null, isEnabled?: boolean | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, isContributor?: boolean | null, aiackowledgement?: boolean | null, roleId?: number | null, workspaceLocationId?: number | null, email: string, phone?: string | null, introVideoLink?: string | null, introVideoText?: string | null, introVideoId?: any | null, profilePhotoLink?: string | null, disclosures?: boolean | null, mentorshipAgreementAcknowledgement?: boolean | null, workspaces: Array<{ __typename?: 'workspaceUsers', workspaceId: number, workspace: { __typename?: 'workspaces', id: number, name: string, aiAnswersEnabled?: boolean | null, inactivityDetectionEnabled?: boolean | null, inactivityLimitMsec?: number | null, locations: Array<{ __typename?: 'workspaceLocations', id: number, name: string, workspaceId: number, abbreviation?: string | null }> } }>, role?: { __typename?: 'roles', id: number, name: string, parentId?: number | null, roleGroup?: { __typename?: 'roles', id: number, name: string } | null } | null, userSpecialty?: { __typename?: 'specialties', id: any, name: string, parentId?: any | null, specialtyGroup?: { __typename?: 'specialties', id: any, name: string } | null } | null, workspaceLocation?: { __typename?: 'workspaceLocations', name: string, abbreviation?: string | null, id: number, city?: string | null, state?: string | null } | null } | null };


export const UpdateUserDocument = gql`
    mutation updateUser($userId: String!, $objects: users_set_input) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: $objects) {
    id
    firstName
    lastName
    profession
    specialty
    specialtyId
    location
    title
    isEnabled
    mentorEnabled
    menteeEnabled
    isContributor
    aiackowledgement
    workspaces(where: {workspace: {active: {_eq: true}}}) {
      workspaceId
      workspace {
        id
        name
        aiAnswersEnabled
        locations(where: {active: {_eq: true}}) {
          id
          name
          workspaceId
          abbreviation
        }
        inactivityDetectionEnabled
        inactivityLimitMsec
      }
    }
    roleId
    role {
      id
      name
      parentId
      roleGroup {
        id
        name
      }
    }
    userSpecialty {
      id
      name
      parentId
      specialtyGroup {
        id
        name
      }
    }
    workspaceLocation {
      name
      abbreviation
      id
      city
      state
    }
    workspaceLocationId
    email
    phone
    introVideoLink
    introVideoText
    introVideoId
    profilePhotoLink
    disclosures
    mentorshipAgreementAcknowledgement
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;